import * as React from 'react';

import { FiltersTabsContainer } from '../../containers/FiltersTabsContainer';
import { FiltersContainer } from '../../containers/FiltersContainer';
import * as styles from './Hero.css';

export class Hero extends React.Component {
  public render() {
    return (
      <div className={styles['wrapper']}>
        <div className={styles['container']}>
          <div className={styles['title']}>Проверенное жильё находится на ЦИАН</div>
          <FiltersTabsContainer />
          <FiltersContainer />
        </div>
      </div>
    );
  }
}
